import { NgModule, ModuleWithProviders } from '@angular/core';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { HotkeyModule, HotkeysService } from 'angular2-hotkeys';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { AngularSplitModule } from 'angular-split';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TagInputModule } from 'ngx-chips';
import { BsDropdownModule, BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { AgGridModule } from 'ag-grid-angular';
import { MomentModule } from 'ngx-moment';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CKControlComponent } from './ckcontrol/ckcontrol.component';
import { DndModule } from 'ngx-drag-drop';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxEditorModule } from 'ngx-editor';
import { NgSelectModule } from '@ng-select/ng-select';
import { QRCodeComponent } from 'angularx-qrcode';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

// Import icons for sidebar menu
import {
  FormOutline,
  ShoppingCartOutline,
  BarChartOutline,
  UserOutline,
  NotificationOutline,
  SettingOutline,
} from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';

const icons: IconDefinition[] = [
  FormOutline,
  ShoppingCartOutline,
  BarChartOutline,
  UserOutline,
  NotificationOutline,
  SettingOutline,
];
@NgModule({
  imports: [
    AccordionModule,
    CommonModule,
    AgGridModule,
    FormsModule,
    ColorPickerModule,
    ReactiveFormsModule,
    NzToolTipModule,
    NzLayoutModule,
    NzMenuModule,
    NzTabsModule,
    NzIconModule.forChild(icons),
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TranslateModule.forChild(),
    HotkeyModule.forRoot(),
    NgxDatatableModule,
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AngularSplitModule,
    TagInputModule,
    BsDropdownModule,
    MomentModule,
    NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        underline: 'Underline',
        strike: 'Strike',
        blockquote: 'Blockquote',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',
        horizontal_rule: 'Horizontal rule',
        format_clear: 'Clear Formatting',
        insertLink: 'Insert Link',
        removeLink: 'Remove Link',
        insertImage: 'Insert Image',
        indent: 'Increase Indent',
        outdent: 'Decrease Indent',
        superscript: 'Superscript',
        subscript: 'Subscript',
        undo: 'Undo',
        redo: 'Redo',

        // pupups, forms, others...
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
        enterValidUrl: 'Please enter a valid URL',
        required: 'This is required',
      },
    }),
    NgSelectModule,
    NzTimelineModule,
    NzDropDownModule,
    UiSwitchModule.forRoot({
      size: 'small',
      color: 'rgb(0, 189, 99)',
      switchColor: '#80FFA2',
      defaultBgColor: '#00ACFF',
      defaultBoColor: '#476EFF',
      checkedLabel: 'on',
      uncheckedLabel: 'off',
    }),
    QRCodeComponent,
  ],
  declarations: [CKControlComponent],
  providers: [TranslateService, HotkeysService, BsModalRef, BsDropdownConfig],
  exports: [
    AccordionModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MomentModule,
    AngularSplitModule,
    TagInputModule,
    HotkeyModule,
    ModalModule,
    TranslatePipe,
    BsDropdownModule,
    AgGridModule,
    NzToolTipModule,
    NzLayoutModule,
    NzMenuModule,
    NzTabsModule,
    NzIconModule,
    CKControlComponent,
    NgxDatatableModule,
    BsDatepickerModule,
    TabsModule,
    AccordionModule,
    DndModule,
    // OverlayPanelModule,
    NgApexchartsModule,
    NgSelectModule,
    QRCodeComponent,
    NzTimelineModule,
    NzDropDownModule,
  ],
})
export class SharedModulesModule {
  constructor(translate: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
  }

  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModulesModule,
      providers: [],
    };
  }
}
